import { Divider, Text, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import useReadCheckoutPrice from '../../../hooks/useReadCheckoutPrice';
import { getFormattedCurrency } from '../../../utils/business/prices';
import CheckoutTaxElement from './CheckoutTaxElement';

const CheckoutTaxes = ({ priceData, checkoutData }) => {
  const { priceTaxIncluded, priceTaxExcluded, taxesLabel, taxesTotal, vakarioFeeLabel, vakarioFeeTotal } = useReadCheckoutPrice(
    priceData,
    checkoutData
  );

  return (
    <VStack minW="180px" maxW={{ base: undefined, md: '250px' }} fontWeight="bold" alignItems="flex-start">
      <CheckoutTaxElement leftPart={<Trans>Sub total</Trans>} rightPart={getFormattedCurrency(priceTaxExcluded)} />

      <CheckoutTaxElement leftPart={<Trans>Tax</Trans>} rightPart={getFormattedCurrency(taxesTotal)} />
      <Text fontSize="9px" fontWeight="500" fontStyle="italic">
        {taxesLabel}
      </Text>

      {vakarioFeeLabel && (
        <>
          <CheckoutTaxElement leftPart={<Trans>Fees</Trans>} rightPart={getFormattedCurrency(vakarioFeeTotal)} />
          <Text fontSize="9px" fontWeight="500" fontStyle="italic">
            {vakarioFeeLabel}
          </Text>
        </>
      )}

      <Divider orientation="horizontal" borderColor="brand.color_main" />

      <CheckoutTaxElement leftPart={<Trans>Total tax incl.</Trans>} rightPart={getFormattedCurrency(priceTaxIncluded)} rightSize="md" />
    </VStack>
  );
};

export default CheckoutTaxes;
